import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useAuthStore } from '@/stores/useAuthStore'
import { ROUTES } from '@/constants/routes'
import { logger } from '@/lib/logger'
import styles from './GoogleLoginButton.module.css'

export function GoogleLoginButton() {
    const navigate = useNavigate()
    const { googleLogin, isLoading } = useAuthStore()

    const handleGoogleLogin = useCallback(async () => {
        // Use Google's OAuth popup
        const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
        if (!clientId) {
            logger.warn('Google Client ID not configured')
            return
        }

        try {
            const google = window.google
            if (!google) {
                toast.error('Google Sign-In not available')
                return
            }

            google.accounts.oauth2.initTokenClient({
                client_id: clientId,
                scope: 'email profile',
                callback: async (response: { access_token?: string; error?: string }) => {
                    if (response.error || !response.access_token) {
                        toast.error('Google sign-in was cancelled')
                        return
                    }
                    const result = await googleLogin(response.access_token)
                    if (result === 'success') {
                        toast.success('Login successful')
                        navigate(ROUTES.projects)
                    }
                },
            }).requestAccessToken()
        } catch (error) {
            logger.error('Google login error', error)
            toast.error('Google login failed')
        }
    }, [googleLogin, navigate])

    return (
        <button
            className={styles.googleButton}
            onClick={handleGoogleLogin}
            disabled={isLoading}
            type="button"
        >
            <svg className={styles.googleIcon} viewBox="0 0 24 24" width="18" height="18">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
        </button>
    )
}
